import { render, staticRenderFns } from "./B2borders.vue?vue&type=template&id=6a3bbe88&scoped=true&"
import script from "./B2borders.vue?vue&type=script&lang=js&"
export * from "./B2borders.vue?vue&type=script&lang=js&"
import style0 from "./B2borders.vue?vue&type=style&index=0&id=6a3bbe88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3bbe88",
  null
  
)

export default component.exports